import { Button, Col, Form, Input, Row, Select, Space } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { SearchOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { DateSelect } from '../../../compnents/form/DateSelect'
import moment from 'moment'
import {
  DateTimeFormat,
  DateTimeFormatSimpleOnlyOne,
} from '../../../models/datetime'
import { RootDispatch } from '../../../app/store'
import { unwrapResult } from '@reduxjs/toolkit'
import { selectTenantId, selectChainId, selectChainType } from '../../../app/applicationSlice'
import { getChainTenantListFn } from '../../chainTransferApplication/chainSlice'
import styles from './varietyManagement.module.css'
const { Option } = Select

export const Query = (props: {
  onValueChange: (queries: any) => void
  export: () => void
  loading?: any
  exportLoading?: any
}): ReactElement => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const chainType = useSelector(selectChainType)

  const [chainList, setChainList] = useState<any>([])

  useEffect(() => {
    if (tenantId == chainId) {
      dispatch(getChainTenantListFn())
        .then(unwrapResult)
        .then((res: any) => {
          setChainList(res?.records)
        })
    }
  }, [])

  return (
    <Form
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      form={form}
      name='control-hooks'
      autoComplete='off'
      onFinish={(vs) => {
        if(!vs?.timeHead && vs?._dateRange == 6){
          return
        }
        props.onValueChange({
          current: 1,
          ...vs,
          timeHead: null,
          timeTail: null,
          startTime: vs?.timeHead
            ? moment(vs?.timeHead).format(DateTimeFormatSimpleOnlyOne)
            : null,
          endTime: vs?.timeTail
            ? moment(vs?.timeTail).format(DateTimeFormatSimpleOnlyOne)
            : null,
        })
      }}
    >
      <Row
        style={{ marginBottom: 10, width: '100%', height: '42px' }}
        align='middle'
        justify='space-between'
      >
        <Space>
          <Form.Item name='goodsName' noStyle>
            <Input
              size='middle'
              placeholder='商品名称'
              allowClear
              onChange={form.submit}
              prefix={<SearchOutlined />}
            />
          </Form.Item>
          <Form.Item name='acceptStatus' noStyle>
            <Select
              placeholder='首营审核状态'
              style={{ width: 150 }}
              allowClear
              onChange={form.submit}
            >
              <Option key={'0'} value={'0'}>
                全部
              </Option>
              <Option key={'-1'} value={'-1'}>
                未审核
              </Option>
              <Option key={'2'} value={'2'}>
                部分审核
              </Option>
              <Option key={'1'} value={'1'}>
                全部已审核
              </Option>
            </Select>
          </Form.Item>
          {(tenantId == chainId && chainType >= 0) ? (
            <Form.Item name='tenantId' noStyle>
              <Select
                placeholder={'选择门店'}
                allowClear
                showSearch
                dropdownClassName={styles.select}
                style={{ width: '16rem' }}
                optionFilterProp='children'
                onChange={form.submit}
              >
                {chainList?.map((v: any, i: any) => {
                  return (
                    <Option value={v.id} key={i}>
                      {v.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          ) : (
            ''
          )}
          <Form.Item name='' noStyle>
            <DateSelect
              placeholder='时间范围'
              style={{ width: '8rem' }}
              onChange={form.submit}
              // initialValue={DateRangeType.Today}
              labelPrefix=''
              namePrefix='time'
              allowClear={true}
            />
          </Form.Item>
          <Button
            loading={props?.loading}
            onClick={form.submit}
            type='primary'
            style={{ float: 'right' }}
          >
            查询
          </Button>
        </Space>
        <Space>
          <Button
            loading={props?.exportLoading}
            onClick={() => {
              props?.export && props?.export()
            }}
            type='primary'
          >
            导出
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
